import AuthService from './AuthService';
import RequestBuilder from '../Lib/Requests';
export default class AssetService {
  auth = new AuthService();
  api = new RequestBuilder();
  buildAssetsRequestForMap(
    {
      children = false,
      includeAlertStatus = true,
      includeAssetCount = true,
      limit = 200,
      orgID = this.auth.getCurrentOrgID(),
      page = 1,
    },
    cancelToken
  ) {
    return {
      service: 'gateway',
      endpoint: '/v2/maps',
      method: 'get',
      params: {
        children,
        includeAlertStatus,
        includeAssetCount,
        limit,
        orgID,
        page,
      },
      cancelToken,
    };
  }
  async getOrgAssetsForMap(params, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildAssetsRequestForMap(params, cancelToken)
    );
    return data;
  }

  handleAdditionalOrgAssetRequests = async (
    count,
    limit,
    orgID,
    cancelToken
  ) => {
    const params = { count, limit, orgID };
    const requestsMap = this.api.createAdditionalRequestMap(
      params,
      this.buildAssetsRequestForMap,
      cancelToken
    );
    return Promise.all(requestsMap);
  };

  handleAdditionalEcosystemAssetRequests = async (
    count,
    limit,
    orgID,
    cancelToken
  ) => {
    const params = { count, limit, orgID, children: true };
    const requestsMap = this.api.createAdditionalRequestMap(
      params,
      this.buildAssetsRequestForMap,
      cancelToken
    );
    return Promise.all(requestsMap);
  };

  buildAssetsRequestForInventory(params, cancelToken) {
    return {
      cancelToken,
      endpoint: '/v2/gateway',
      method: 'get',
      params,
      service: 'gateway',
    };
  }
  getOrgAssetsForInventory = async (
    {
      children = false,
      limit = 10,
      order = 'ASC',
      orgID = this.auth.getCurrentOrgID(),
      page = 1,
      search = '',
      shadow = true,
      sort = 'nickname',
    },
    cancelToken
  ) => {
    const { data = {} } = await this.api.request(
      this.buildAssetsRequestForInventory(
        {
          children,
          limit,
          order,
          orgID,
          page,
          search,
          shadow,
          sort,
        },
        cancelToken
      )
    );
    return data;
  };

  buildFetchProvisionedAssetsRequest(params, cancelToken) {
    return {
      service: 'gateway',
      endpoint: '/provision',
      method: 'get',
      params,
      cancelToken,
    };
  }
  fetchProvisionedAssets = async (params, cancelToken) => {
    const { data = {} } = await this.api.request(
      this.buildFetchProvisionedAssetsRequest(params, cancelToken)
    );
    return data;
  };

  buildProvisionAssetRequest(vendor, data, cancelToken) {
    return {
      cancelToken,
      data,
      endpoint: `/provision/${vendor}`,
      method: 'post',
      service: 'gateway',
    };
  }
  async provisionAsset(vendor, body, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildProvisionAssetRequest(vendor, body, cancelToken)
    );
    return data;
  }

  buildProvisionAssetBulkRequest(data, orgID) {
    return {
      service: 'gateway',
      endpoint: '/provision/bulk',
      method: 'post',
      params: { orgID },
      data,
    };
  }
  async ProvisionAssetBulk(body, orgID) {
    const { data = {} } = await this.api.request(
      this.buildProvisionAssetBulkRequest(body, orgID)
    );
    return data;
  }

  buildCreateAssetRequest(data) {
    return {
      service: 'gateway',
      endpoint: '/gateway',
      method: 'post',
      data,
    };
  }
  async createAsset(body) {
    const { data = {} } = await this.api.request(
      this.buildCreateAssetRequest(body)
    );
    return data;
  }

  buildMoveAssetToNewOrgRequest(assetID, data) {
    return {
      service: 'gateway',
      endpoint: `/gateway/${assetID}/org`,
      method: 'put',
      data,
    };
  }
  async moveAssetToNewOrg(assetID, body) {
    const { data = {} } = await this.api.request(
      this.buildMoveAssetToNewOrgRequest(assetID, body)
    );
    return data;
  }

  buildDeleteAssetRequest(assetID, cancelToken) {
    return {
      cancelToken,
      endpoint: `/gateway/${assetID}`,
      method: 'delete',
      service: 'gateway',
    };
  }
  async deleteAsset(assetID, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildDeleteAssetRequest(assetID, cancelToken)
    );
    return data;
  }

  buildDeleteProvisionRequest(provisionID) {
    return {
      service: 'gateway',
      endpoint: `/provision/${provisionID}`,
      method: 'delete',
    };
  }
  async deleteProvisionRequest(provisionID) {
    const { data = {} } = await this.api.request(
      this.buildDeleteProvisionRequest(provisionID)
    );
    return data;
  }

  buildFetchAssetRequest({ assetID, ...params }, cancelToken) {
    return {
      service: 'gateway',
      endpoint: `/gateway/${assetID}`,
      method: 'get',
      params,
      cancelToken,
    };
  }
  async fetchAsset(params, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildFetchAssetRequest(params, cancelToken)
    );
    return data;
  }

  buildFetchAllAssetsRequest(orgID, cancelToken) {
    return {
      service: 'gateway',
      endpoint: '/gateway/all',
      method: 'get',
      params: { orgID },
      cancelToken,
    };
  }
  async fetchAllAssets(orgID, cancelToken) {
    const { data = [] } = await this.api.request(
      this.buildFetchAllAssetsRequest(orgID, cancelToken)
    );
    return data;
  }

  buildGetEcosystemAssetsForService({
    orgID = this.auth.getCurrentOrgID(),
    cancelToken,
  }) {
    return {
      service: 'gateway',
      endpoint: '/v2/gateway',
      method: 'get',
      params: {
        orgID,
        shadow: true,
        children: true,
      },
      cancelToken,
    };
  }
  getEcosystemAssetsForService = async (params) => {
    const { data = {} } = await this.api.request(
      this.buildGetEcosystemAssetsForService(params)
    );
    return data;
  };
  buildAssetUpdateRequest(assetID, data, cancelToken) {
    return {
      service: 'gateway',
      endpoint: `/gateway/${assetID}`,
      method: 'put',
      data,
      cancelToken,
    };
  }
  async updateAssetDetails(assetID, update, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildAssetUpdateRequest(assetID, update, cancelToken)
    );
    return data;
  }

  buildUpdateAssetRemoteRequest(assetID, enable, cancelToken) {
    return {
      service: 'gateway',
      endpoint: `/gateway/${assetID}/remote`,
      method: 'post',
      params: { enable },
      cancelToken,
    };
  }
  async updateAssetRemote(assetID, enable, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildUpdateAssetRemoteRequest(assetID, enable, cancelToken)
    );
    return data;
  }

  buildExecuteAssetCommandRequest(assetID, params, data, cancelToken) {
    return {
      service: 'gateway',
      endpoint: `/gateway/${assetID}/job`,
      method: 'post',
      params,
      data,
      cancelToken,
    };
  }
  async executeAssetCommand(assetID, params, body, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildExecuteAssetCommandRequest(assetID, params, body, cancelToken)
    );
    return data;
  }

  buildGenerateCertificateRequest(assetID, cancelToken) {
    return {
      service: 'gateway',
      endpoint: `/gateway/${assetID}/certificate`,
      method: 'post',
      cancelToken,
    };
  }
  async generateCertificate(assetID, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildGenerateCertificateRequest(assetID, cancelToken)
    );
    return data;
  }

  buildFetchAssetsRequest(params, cancelToken) {
    return {
      service: 'gateway',
      endpoint: '/v2/gateway',
      method: 'get',
      params,
      cancelToken,
    };
  }
  async fetchAssets(params, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildFetchAssetsRequest(params, cancelToken)
    );
    return data;
  }

  buildExportAllAssetByOrgRequest(params, cancelToken) {
    return {
      service: 'gateway',
      endpoint: '/gateway/export',
      method: 'get',
      params,
      cancelToken,
    };
  }
  async exportAllAssetsByOrg(params, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildExportAllAssetByOrgRequest(params, cancelToken)
    );
    return data;
  }

  buildAssetSearchRequest(params, cancelToken) {
    return {
      service: 'gateway',
      endpoint: '/v2/gateway/search',
      method: 'get',
      params,
      cancelToken,
    };
  }
  async searchAssets(params, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildAssetSearchRequest(params, cancelToken)
    );
    return data;
  }

  buildFetchModelByTemplateIdRequest(templateID, cancelToken) {
    return {
      service: 'gateway',
      endpoint: `/template/${templateID}`,
      method: 'get',
      cancelToken,
    };
  }
  async fetchModelByTemplateId(templateID, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildFetchModelByTemplateIdRequest(templateID, cancelToken)
    );
    return data;
  }

  buildFetchModelByAssetIdRequest(assetID, cancelToken) {
    return {
      service: 'gateway',
      endpoint: `/gateway/${assetID}/template`,
      method: 'get',
      cancelToken,
    };
  }
  async fetchModelByAssetId(assetID, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildFetchModelByAssetIdRequest(assetID, cancelToken)
    );
    return data;
  }
  buildFetchAssetOTA(assetID, cancelToken) {
    return {
      service: 'gateway',
      endpoint: `/gateway/${assetID}/ota`,
      method: 'get',
      cancelToken,
    };
  }
  async fetchAssetOTA(assetID, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildFetchAssetOTA(assetID, cancelToken)
    );
    return data;
  }
  buildFetchAssetTwin(assetID, cancelToken) {
    return {
      service: 'gateway',
      endpoint: `/gateway/${assetID}/twin`,
      method: 'get',
      cancelToken,
    };
  }
  async fetchAssetTwin(assetID, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildFetchAssetTwin(assetID, cancelToken)
    );
    return data;
  }
  buildFetchAssetTwin2(assetID, cancelToken) {
    return {
      service: 'gateway',
      endpoint: `/gateway/${assetID}/twin2`,
      method: 'get',
      cancelToken,
    };
  }
  async fetchAssetTwin2(assetID, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildFetchAssetTwin2(assetID, cancelToken)
    );
    return data;
  }
  buildFetchAssetIdentity(assetID, cancelToken) {
    return {
      service: 'gateway',
      endpoint: `/gateway/${assetID}/identity`,
      method: 'get',
      cancelToken,
    };
  }
  async fetchAssetIdentity(assetID, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildFetchAssetIdentity(assetID, cancelToken)
    );
    return data;
  }
  buildFetchAssetIdentity2(assetID, cancelToken) {
    return {
      service: 'gateway',
      endpoint: `/gateway/${assetID}/identity2`,
      method: 'get',
      cancelToken,
    };
  }
  async fetchAssetIdentity2(assetID, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildFetchAssetIdentity2(assetID, cancelToken)
    );
    return data;
  }
  buildFetchAssetDeviceStreamsInfo(assetID, cancelToken) {
    return {
      service: 'gateway',
      endpoint: `/gateway/${assetID}/deviceStream`,
      method: 'get',
      cancelToken,
    };
  }
  async fetchAssetDeviceStreamsInfo(assetID, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildFetchAssetDeviceStreamsInfo(assetID, cancelToken)
    );
    return data;
  }
  buildUpdateAssetSoftware(assetID, params, cancelToken) {
    return {
      service: 'gateway',
      endpoint: `/gateway/${assetID}/ota`,
      method: 'post',
      params,
      cancelToken,
    };
  }
  async updateAssetSoftware(assetID, params, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildUpdateAssetSoftware(assetID, params, cancelToken)
    );
    return data;
  }

  buildSetAwsKeysRequest(params, data, cancelToken) {
    return {
      service: 'gateway',
      endpoint: '/v1/keys',
      method: 'put',
      cancelToken,
      data,
      params,
    };
  }
  setAwsKeys(params, data, cancelToken) {
    return this.api.request(
      this.buildSetAwsKeysRequest(params, data, cancelToken)
    );
  }

  buildDeleteAwsKeysRequest(params, cancelToken) {
    return {
      service: 'gateway',
      endpoint: '/v1/keys',
      method: 'put',
      cancelToken,
      params,
    };
  }
  deleteAwsKeys(params, cancelToken) {
    return this.api.request(
      this.buildDeleteAwsKeysRequest(params, cancelToken)
    );
  }

  buildFetchAssetSnapshotsRequest(gatewayID, params, cancelToken) {
    return {
      cancelToken,
      endpoint: `/gateway/${gatewayID}/snapshots`,
      method: 'get',
      params,
      service: 'gateway',
    };
  }
  async fetchAssetSnapshots(gatewayID, params, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildFetchAssetSnapshotsRequest(gatewayID, params, cancelToken)
    );
    return data;
  }

  buildFetchAssetFcNotificationsRequest(gatewayID, params, cancelToken) {
    return {
      cancelToken,
      endpoint: `/gateway/${gatewayID}/fcNotifications`,
      method: 'get',
      params,
      service: 'gateway',
    };
  }
  async fetchAssetFcNotifications(gatewayID, params, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildFetchAssetFcNotificationsRequest(gatewayID, params, cancelToken)
    );
    return data;
  }

  buildFetchAssetFcNotificationMetricsRequest(gatewayID, params, cancelToken) {
    return {
      cancelToken,
      endpoint: `/gateway/${gatewayID}/fcNotifications-filters`,
      method: 'get',
      params,
      service: 'gateway',
    };
  }
  async fetchAssetFcNotificationMetrics(gatewayID, params, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildFetchAssetFcNotificationMetricsRequest(
        gatewayID,
        params,
        cancelToken
      )
    );
    return data;
  }

  buildFetchCumminsResponseRequest(gatewayID, timestamp, cancelToken) {
    return {
      cancelToken,
      endpoint: `/gateway/${gatewayID}/diagnosticResponse/${timestamp}`,
      method: 'get',
      service: 'gateway',
    };
  }
  async fetchCumminsResponse(gatewayID, timestamp, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildFetchCumminsResponseRequest(gatewayID, timestamp, cancelToken)
    );
    return data;
  }

  buildValidateAssetRequest(gatewayID, templateID, cancelToken) {
    return {
      cancelToken,
      endpoint: `/gateway/${gatewayID}/validate/${templateID}`,
      method: 'post',
      service: 'gateway',
    };
  }
  async validateAsset(gatewayID, templateID, cancelToken) {
    return this.api.request(
      this.buildValidateAssetRequest(gatewayID, templateID, cancelToken)
    );
  }

  buildFetchAssetCustomerOTAs(assetID, cancelToken) {
    return {
      service: 'gateway',
      endpoint: `/gateway/${assetID}/customerOta`,
      method: 'get',
      cancelToken,
    };
  }
  async fetchAssetCustomerOTAs(assetID, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildFetchAssetCustomerOTAs(assetID, cancelToken)
    );
    return data;
  }

  buildAddAssetCustomerOTA(assetID, data, cancelToken) {
    return {
      data,
      service: 'gateway',
      endpoint: `/gateway/${assetID}/customerOta`,
      method: 'post',
      cancelToken,
    };
  }
  async addAssetCustomerOTA(assetID, body, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildAddAssetCustomerOTA(assetID, body, cancelToken)
    );
    return data;
  }

  buildDeleteAssetCustomerOTA(assetID, params, cancelToken) {
    return {
      params,
      service: 'gateway',
      endpoint: `/gateway/${assetID}/customerOta`,
      method: 'delete',
      cancelToken,
    };
  }
  async deleteAssetCustomerOTA(assetID, params, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildDeleteAssetCustomerOTA(assetID, params, cancelToken)
    );
    return data;
  }

  buildAssetAssociationExistsRequest(assetID, cancelToken) {
    return {
      cancelToken,
      endpoint: `/v2/gateway/${assetID}/assetAssociationExists`,
      method: 'get',
      service: 'gateway',
    };
  }
  async assetAssociationExists(assetID, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildAssetAssociationExistsRequest(assetID, cancelToken)
    );
    return data;
  }

  buildListActivationCodesRequest(assetID, params, cancelToken) {
    return {
      cancelToken,
      endpoint: `/v2/gateway/${assetID}/activationCodes`,
      method: 'get',
      params,
      service: 'gateway',
    };
  }
  async listActivationCodes(assetID, params, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildListActivationCodesRequest(assetID, params, cancelToken)
    );
    return data;
  }
}
